const styles = (theme) => ({
  root: {
    width: '100%',
    borderRadius: '20px',
    backgroundColor: '#FFF',
  },
})

export default styles
